/*
 * Escala de breakpoints: única fuente de los anchos de pantalla de la app.
 *
 * Las variables CSS no funcionan dentro de @media (y CRA no habilita @custom-media), así que en
 * los CSS Modules se escribe el valor literal; tokens.css documenta esta misma escala.
 *
 *   mobile           0 – 767
 *   tabletPortrait 768 – 1023
 *   tabletLandscape 1024 – 1279
 *   desktop       1280 – 1919
 *   monitor1080   1920+
 */

export const BREAKPOINTS = {
  tabletPortrait: 768,
  tabletLandscape: 1024,
  desktop: 1280,
  monitor1080: 1920,
};

// Queries listas para useMediaQuery (hooks/useMediaQuery.js).
export const MEDIA = {
  mobile: `(max-width: ${BREAKPOINTS.tabletPortrait - 1}px)`,
  tabletPortraitDown: `(max-width: ${BREAKPOINTS.tabletLandscape - 1}px)`,
  // Móvil + tablet: el sidebar se abre desde el botón hamburguesa del navbar.
  tabletDown: `(max-width: ${BREAKPOINTS.desktop - 1}px)`,
  desktopUp: `(min-width: ${BREAKPOINTS.desktop}px)`,
  monitor1080Up: `(min-width: ${BREAKPOINTS.monitor1080}px)`,
};
